// originally from image-experience/imageCommonStyles, so common across legacy UI and ui-next

export const getCommonPreviewContainerStyles = () => ({
  '& .new-responsive-ad-preview-container': {
    fontFamily: '"Segoe UI","Segoe WP",Arial,Sans-Serif',
    fontSize: 10,
    height: 620,
    position: 'relative',
  },
  '& .new-responsive-ad-preview-container .responsive-ad-preview-content': {
    boxSizing: 'unset',
    position: 'absolute',
    top: '47%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    margin: '0',
    overflow: 'hidden',
  },
  '& .new-responsive-ad-preview-container .preview-type-string': {
    position: 'absolute',
    bottom: 75,
    fontSize: 12,
    textAlign: 'center',
    width: '100%',
  },
  '& .preview-section': {
    border: '1px solid #C8C8C8',
    padding: '20px 24px',

    '& .preview-section-title': {
      fontSize: 18,
      fontWeight: 'normal',
      lineHeight: '24px',
    },
  },
  '& .disclaimer-info, & .additional-disclaimer': {
    fontSize: 12,
    lineHeight: '20px',
    textAlign: 'left',
  },
  '& .disclaimer-info': {
    padding: '0 24px 20px 24px',
  },

  '& .additional-disclaimer': {
    bottom: 0,
    padding: '0 24px',
  },

  '& .panel-content': {
    '@media screen and (max-width: 1400px)': {
      maxWidth: '90%',
    },
  },
});
